import React, { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Card, Button, List, Tooltip, Typography } from 'antd'
import { ArrowRightOutlined, SyncOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { getPlans } from '../../Actions/plansApi'

const { Text } = Typography

function PlansWidget() {
  const [posts, setPosts] = useState([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [page, setPage] = useState(0)
  const { isLoading, refetch, data } = useQuery({
    queryKey: ['getPlans', page],
    queryFn: () => getPlans(page),
    onError: (error) => {
      console.log(error)
    },
  })

  useEffect(() => {
    if (data) {
      setPosts(data.content)
    }
  }, [data])

  return (
    <Card
      title={
        <Link to="/plan">
          플랜 <ArrowRightOutlined />
        </Link>
      }
      headStyle={{ paddingInline: '16px' }}
      bodyStyle={{ padding: 0 }}
      loading={isLoading}
      extra={
        <Tooltip title="새로고침">
          <Button shape="circle" size="small" onClick={refetch} icon={<SyncOutlined />} loading={isLoading} />
        </Tooltip>
      }
    >
      <List itemLayout="vertical" size="small">
        {posts &&
          posts
            .map((plan) => (
              <List.Item
                key={`${plan.createdAt}-${Math.floor(Math.random() * 100)}${1}`}
                extra={<Text type="secondary">{plan.createdAt.slice(0, 10)}</Text>}
              >
                {plan.name}
              </List.Item>
            ))
            .slice(0, 5)}
      </List>
    </Card>
  )
}
export default PlansWidget
